export default "__VITE_ASSET__67148b51__"